import React from "react";

const Secfooter = () => {
  return (
    <div className="mainsecfooterdiv">
      <div className="secfooterdiv">
        <div>
          <h2>Frequently searched careers</h2>
        </div>
        <div>
          <ul>
            <li>Security Guard</li>
            <li>Software Engineer</li>
            <li>Accountant</li>
            <li>Data Entry Clerk</li>
            <li>Teacher</li>
            <li>Computer Operator</li>
            <li>Nurse</li>
            <li>Laboratory Technician</li>
            <li>Driver</li>
            <li>Pharmacist</li>
            <li>Architect</li>
            <li>Computer Engineer</li>
            <li>Mechanical Engineer</li>
            <li>Civil Engineer</li>
            <li>Engineer</li>
          </ul>
        </div>
        <div>
          <ul>
            <li>High School Teacher</li>
            <li>Graphic Designer</li>
            <li>Assistant Professor</li>
            <li>Physiotherapist</li>
            <li>Full Stack Developer</li>
            <li>Radiologist</li>
            <li>Back Office Executive</li>
            <li>Electrical Engineer</li>
            <li>Electrician</li>
            <li>Medical Representative</li>
            <li>Flight Attendant</li>
            <li>Web Developer</li>
            <li>Data Scientist</li>
            <li>Veterinarian</li>
            <li>Police Officer</li>
          </ul>
        </div>
        <div>
          <ul>
            <li>Registered Nurse</li>
            <li>CNC Operator</li>
            <li>Counselor</li>
            <li>School Teacher</li>
            <li>Office Assistant</li>
            <li>Collectort</li>
            <li>Medical Officer</li>
            <li>Data Analyst</li>
            <li>Digital Marketer</li>
            <li>Bus Driver</li>
            <li>Microbiologist</li>
            <li>Housekeeper</li>
            <li>Interior Designer</li>
            <li>Firefighter</li>
            <li>Stenographer</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Secfooter;
